import React from 'react';
import { Link } from 'react-router-dom';
import { FaCamera } from 'react-icons/fa';

/**
 * AdvertiseYourselfCTA
 *
 * Fast platform-element ("Vil du vises her? Bliv sponsor og nå tusindvis af
 * slushice-elskere hver dag") der ligger under opskriftslisten. Går altid
 * til /advertise. Vises kun for brugere der ser reklamer (samme
 * `userSeesAds`-regel som resten).
 */
const AdvertiseYourselfCTA = () => {
  return (
    <div
      className="mt-8 rounded-2xl border border-amber-200 bg-amber-50 px-6 py-4 flex flex-col sm:flex-row sm:items-center gap-3"
      data-testid="advertise-yourself-cta"
    >
      <div className="flex items-center gap-3 flex-1">
        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center text-amber-700 shrink-0">
          <FaCamera className="w-4 h-4" />
        </div>
        <div>
          <div className="font-semibold text-amber-900">Vil du vises her?</div>
          <div className="text-sm text-amber-800">
            Bliv sponsor og nå tusindvis af slushice-elskere hver dag.
          </div>
        </div>
      </div>
      <Link
        to="/advertise"
        className="text-sm font-semibold text-amber-900 hover:text-amber-700 whitespace-nowrap"
        data-testid="advertise-yourself-cta-link"
      >
        Læs mere om sponsorater →
      </Link>
    </div>
  );
};

export default AdvertiseYourselfCTA;
